import releaseOfPersonalInformationAgreement from "./releaseOfPersonalInformationAgreement";

const agreementService = [
    {
        matcher: 'releaseOfPersonalInformationAgreement',
        reply: config => {
            return [200, releaseOfPersonalInformationAgreement];
        }
    }
]

export default agreementService;